/* eslint-disable */
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "prismjs/themes/prism-coy.css";
import "./shared/styles/index.scss";
import "./shared/flags/flags.css";

import { createApp, reactive } from "vue";
import router from "./router";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import AutoComplete from "primevue/autocomplete";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Avatar from "primevue/avatar";
import AvatarGroup from "primevue/avatargroup";
import Badge from "primevue/badge";
import BadgeDirective from "primevue/badgedirective";
import Button from "primevue/button";
import Breadcrumb from "primevue/breadcrumb";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Carousel from "primevue/carousel";
import Chart from "primevue/chart";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import Chips from "primevue/chips";
import ColorPicker from "primevue/colorpicker";
import Column from "primevue/column";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmationService from "primevue/confirmationservice";
import ContextMenu from "primevue/contextmenu";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Dropdown from "primevue/dropdown";
import Fieldset from "primevue/fieldset";
import FileUpload from "@/shared/ui/FileUpload.vue";
import InlineMessage from "primevue/inlinemessage";
import Inplace from "primevue/inplace";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Knob from "primevue/knob";
import Galleria from "primevue/galleria";
import Listbox from "primevue/listbox";
import MegaMenu from "primevue/megamenu";
import Menu from "primevue/menu";
import Menubar from "primevue/menubar";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import OrderList from "primevue/orderlist";
import OrganizationChart from "primevue/organizationchart";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Panel from "primevue/panel";
import PanelMenu from "primevue/panelmenu";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import Rating from "primevue/rating";
import RadioButton from "primevue/radiobutton";
import Ripple from "primevue/ripple";
import SelectButton from "primevue/selectbutton";
import ScrollPanel from "primevue/scrollpanel";
import ScrollTop from "primevue/scrolltop";
import Slider from "primevue/slider";
import Sidebar from "primevue/sidebar";
import Skeleton from "primevue/skeleton";
import SplitButton from "primevue/splitbutton";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Steps from "primevue/steps";
import StyleClass from "primevue/styleclass";
import TabMenu from "primevue/tabmenu";
import Tag from "primevue/tag";
import TieredMenu from "primevue/tieredmenu";
import Textarea from "primevue/textarea";
import Timeline from "primevue/timeline";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Toolbar from "primevue/toolbar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Tooltip from "primevue/tooltip";
import ToggleButton from "primevue/togglebutton";
import Tree from "primevue/tree";
import TreeTable from "primevue/treetable";
import TriStateCheckbox from "primevue/tristatecheckbox";
import { VueperSlides, VueperSlide } from "vueperslides";
import {
  ErrorMessage,
  FormInput,
  FormInputLabel,
  FormTextarea,
  FormSelect,
  FormToggleButton,
  LocalFileUpload,
} from "@/shared/ui";
import axios from "axios";
import store from "./store";
import ProgressSpinner from "primevue/progressspinner";

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

const app = createApp(App);

app.config.globalProperties.$appState = reactive({
  theme: "lara-light-indigo",
  darkTheme: false,
});

app.use(PrimeVue, { ripple: true, inputStyle: "outlined" });
app.use(ConfirmationService);
app.use(ToastService);
app.use(router);
app.use(store);

app.directive("tooltip", Tooltip);
app.directive("ripple", Ripple);
app.directive("badge", BadgeDirective);
app.directive("styleclass", StyleClass);

app.component("ProgressSpinner", ProgressSpinner);
app.component("LocalFileUpload", LocalFileUpload);
app.component("FormInput", FormInput);
app.component("FormToggleButton", FormToggleButton);
app.component("ErrorMessage", ErrorMessage);
app.component("FormInputLabel", FormInputLabel);
app.component("FormTextarea", FormTextarea);
app.component("FormSelect", FormSelect);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("AutoComplete", AutoComplete);
app.component("Avatar", Avatar);
app.component("AvatarGroup", AvatarGroup);
app.component("Badge", Badge);
app.component("Breadcrumb", Breadcrumb);
app.component("Button", Button);
app.component("Calendar", Calendar);
app.component("Card", Card);
app.component("Carousel", Carousel);
app.component("Chart", Chart);
app.component("Checkbox", Checkbox);
app.component("Chip", Chip);
app.component("Chips", Chips);
app.component("ColorPicker", ColorPicker);
app.component("Column", Column);
app.component("ConfirmDialog", ConfirmDialog);
app.component("ConfirmPopup", ConfirmPopup);
app.component("ContextMenu", ContextMenu);
app.component("DataTable", DataTable);
app.component("DataView", DataView);
app.component("DataViewLayoutOptions", DataViewLayoutOptions);
app.component("Dialog", Dialog);
app.component("Divider", Divider);
app.component("Dropdown", Dropdown);
app.component("Fieldset", Fieldset);
app.component("FileUpload", FileUpload);
app.component("InlineMessage", InlineMessage);
app.component("Inplace", Inplace);
app.component("InputMask", InputMask);
app.component("InputNumber", InputNumber);
app.component("InputSwitch", InputSwitch);
app.component("InputText", InputText);
app.component("Galleria", Galleria);
app.component("Knob", Knob);
app.component("Listbox", Listbox);
app.component("MegaMenu", MegaMenu);
app.component("Menu", Menu);
app.component("Menubar", Menubar);
app.component("Message", Message);
app.component("MultiSelect", MultiSelect);
app.component("OrderList", OrderList);
app.component("OrganizationChart", OrganizationChart);
app.component("OverlayPanel", OverlayPanel);
app.component("Paginator", Paginator);
app.component("Panel", Panel);
app.component("PanelMenu", PanelMenu);
app.component("Password", Password);
app.component("PickList", PickList);
app.component("ProgressBar", ProgressBar);
app.component("RadioButton", RadioButton);
app.component("Rating", Rating);
app.component("SelectButton", SelectButton);
app.component("ScrollPanel", ScrollPanel);
app.component("ScrollTop", ScrollTop);
app.component("Slider", Slider);
app.component("Sidebar", Sidebar);
app.component("Skeleton", Skeleton);
app.component("SplitButton", SplitButton);
app.component("Splitter", Splitter);
app.component("SplitterPanel", SplitterPanel);
app.component("Steps", Steps);
app.component("TabMenu", TabMenu);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Tag", Tag);
app.component("Textarea", Textarea);
app.component("TieredMenu", TieredMenu);
app.component("Timeline", Timeline);
app.component("Toast", Toast);
app.component("Toolbar", Toolbar);
app.component("ToggleButton", ToggleButton);
app.component("Tree", Tree);
app.component("TreeTable", TreeTable);
app.component("TriStateCheckbox", TriStateCheckbox);
app.component("VueperSlides", VueperSlides);
app.component("VueperSlide", VueperSlide);

app.mount("#app");

// Dev only. `import.meta.env.DEV` is replaced with `false` at build time, so the branch and the
// chunk it pulls in are both eliminated from production.
if (import.meta.env.DEV) {
  import("./shared/services/sg-library/lib/fault-injection")
    .then((module) => module.expose())
    .catch(() => {
      // Never let a debugging aid take the app down with it.
    });
}

// Axios configuration
axios.interceptors.request.use(
  function (config) {
    const token = store.state.user.token;
    if (
      token != undefined &&
      !config.url.includes("login") &&
      !config.url.includes("refresh")
    ) {
      applyAuthHeader(config, token);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let subscribers = [];

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const config = err?.config;
    const response = err?.response;

    // A request that never reached the server - network failure, timeout, cancellation -
    // carries no response, and no part of the refresh flow below can apply to it.
    // Destructuring one here used to throw inside this handler, which replaced the real
    // error with a TypeError and lost the original.
    if (!response || !config) {
      return Promise.reject(err);
    }

    const status = response.status;
    const data = response.data && typeof response.data === "object" ? response.data : {};

    const originalRequest = config;
    const requestUrl = originalRequest.url ?? "";
    const stor = localStorage.getItem("refresh");
    if (
      data.error != undefined &&
      data.error != null &&
      data.error != "" &&
      requestUrl.includes("refresh")
    ) {
      onRefreshFailed(err);
      router.push({ name: "login" });
      return Promise.reject(false);
    }
    if (stor === undefined || stor === "") {
      router.push({ name: "login" });
      return Promise.reject(false);
    }

    if (requestUrl.includes("refresh")) {
      return Promise.reject(err);
    }
    if (originalRequest.headers?.Authorization == null || stor == "" || stor == undefined) {
      router.push({ name: "login" });
      localStorage.removeItem("refresh");
      localStorage.removeItem("access_token");
      return Promise.reject(false);
    }

    if (status === 401 && stor != undefined && stor != "") {
      if (!isRefreshing) {
        isRefreshing = true;
        store
          .dispatch("REFRESH_TOKEN")
          .then(() => {
            isRefreshing = false;
            onRefreshed();
          })
          .catch((refreshError) => {
            isRefreshing = false;
            localStorage.removeItem("refresh");
            localStorage.removeItem("access_token");
            onRefreshFailed(refreshError);
          });
      }

      const requestSubscribers = new Promise((resolve, reject) => {
        subscribeTokenRefresh(
          (token) => {
            applyAuthHeader(originalRequest, token);
            resolve(axios(originalRequest));
          },
          (reason) => reject(reason),
        );
      });

      return requestSubscribers;
    } else {
      return Promise.reject({ status, response: data });
    }
  }
);

// Both interceptors set this header, and a retry passes through both. They must agree:
// when only one of them merged, a retried request lost the Content-Type its body had
// already been serialised against and the API answered 415.
function applyAuthHeader(config, token) {
  const url = config.url ?? "";
  const bearer =
    url.startsWith(import.meta.env.VITE_API_V4_URI) && !token.length ? "not-found" : token;

  config.headers = { ...config.headers, Authorization: `Bearer ${bearer}` };
}

function subscribeTokenRefresh(onToken, onFailure) {
  subscribers.push({ onToken, onFailure });
}

function onRefreshed() {
  const pending = subscribers;
  subscribers = [];
  pending.forEach(({ onToken, onFailure }) => {
    // The queue is already cleared, so a subscriber that throws here would leave its
    // request pending forever - which is what happened when a refresh succeeded with no
    // token in the response body.
    try {
      onToken(store.state.user.token);
    } catch (error) {
      onFailure(error);
    }
  });
}

// A failed refresh has to settle everything queued behind it. Clearing the list without
// invoking anything left those promises pending forever, so a request that hit a 401 during
// a failed refresh never resolved and never rejected.
function onRefreshFailed(reason) {
  const pending = subscribers;
  subscribers = [];
  pending.forEach(({ onFailure }) => onFailure(reason));
}
